import { Component } from '@angular/core';
import {Base64ImageComponent} from "../base64-image/base64-image.component";
import {UsersService} from "../../services/users.service";
import {Store} from "@ngrx/store";
import {User} from "../../auth/primitives/user";

import * as AuthSelectors from '../../state/auth/auth.selector';
import {authActions} from "../../state/auth/auth.actions";
import {ProfileImageComponent} from "../profile-image/profile-image.component";
import {DoWhenReadyService, Readyables} from "../../services/do-when-ready.service";
import {NgIf} from "@angular/common";
import {IconsService} from "../../services/icons.service";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {Router} from "@angular/router";

@Component({
  selector: 'pane-profile-dropdown',
  standalone: true,
  imports: [
    Base64ImageComponent,
    NgIf,
    FaIconComponent
  ],
  templateUrl: './pane-profile-dropdown.component.html',
  styleUrl: './pane-profile-dropdown.component.scss'
})
export class PaneProfileDropdownComponent {

  user: User

  constructor(
      private userService: UsersService,
      private store: Store,
      private doWhenReady: DoWhenReadyService,
      public iconsService: IconsService,
      private router: Router
  ) {
    this.doWhenReady.firstTime(this, [Readyables.network], (user) => {
      this.user = user
    })
  }


  editProfile() {
    this.router.navigate([{outlets: {'right-pane': "profile-edit"}}])
  }

  profile() {
    this.router.navigate([{outlets: {'right-pane': "profile"}}])
  }

  logout() {
    this.store.dispatch(authActions.logoutUser())
  }

  protected readonly location = location;
}
